import React from 'react';
import { Helmet } from 'react-helmet-async';
import CenterPageLayoutNew from 'web/components/CenterPageLayoutNew';
import IubendaViewer from 'web/components/IubendaViewer';
import BodyBackground from 'web/styles/BodyBackground';
import ScreenTracker from 'web/components/ScreenTracker';

const TermsOfService = () => (
  <>
    <Helmet title="Terms of Service" />
    <ScreenTracker screenName="TermsOfService" />
    <BodyBackground color="#FFEBE0" />
    <CenterPageLayoutNew>
      <IubendaViewer
        policyUrl="https://www.iubenda.com/api/terms-and-conditions/54070999"
        cypressId="terms-of-service"
      />
    </CenterPageLayoutNew>
  </>
);

export default TermsOfService;
